import { createSelector } from '@ngrx/store';
import { addressProviderState } from '../root';

export const getAddressProviderReverseGeocodePlaces = (geolocation: OLO.DTO.GeolocationDto) =>
    createSelector(
        addressProviderState,
        (addressProvider) =>
            addressProvider?.geocoder.filter(
                (place) => place.hasSucceeded && place.data?.length && place.geolocation.Latitude === geolocation.Latitude && place.geolocation.Longitude === geolocation.Longitude,
            ) ?? [],
    );
